{
  "name": "Carlos Keglevich",
  "title": "Software Engineer",
  "about": "About",
  "projects": "Projects",
  "footerMessage": "Designed & developed by",
  "aboutSection": {
    "heading": "About me",
    "block1": {
      "title": "From business to codebase",
      "text": "Before software, I worked where mistakes are expensive: procurement and data analysis in international trade, criminal investigation in public service, precision manufacturing in the USA and Germany. That gave me domain knowledge in finance, security, and operations that most developers only meet through tickets — I've lived the processes I now automate."
    },
    "block2": {
      "title": "Built for quality",
      "text": "Quality is not a phase at the end — it's how I work from the first commit. Documented APIs, clear architecture, and high test coverage are my default, because software only creates value when the next person can maintain, extend, and trust it."
    },
    "block3": {
      "title": "What you can rely on",
      "text": "I spent many years in professions where quality, precision, security, and confidentiality were non-negotiable. From them I bring what teams actually need day to day: a structured, self-reliant way of working, calm under time pressure, Lean/Kanban experience from real production lines, and clear communication in German, English, and Portuguese. Done means tested, documented, and deployed."
    },
    "block4": {
      "title": "Where I'm heading",
      "text": "I go deeper into software engineering for one reason: I want to make complex systems simpler, safer, and more reliable. That's what I build for — software that keeps a business running on its worst day and lets it grow on its best."
    },
    "careerHeading": "Career at a glance",
    "educationHeading": "Education & certification",
    "career": [
      "11.2024 – present · SmartSupplyPro — full-stack development (Java/Spring Boot, React), personal production project",
      "04.2023 – 08.2025 · Duagon GmbH — machine operator & software analyst, electronics manufacturing",
      "03.2019 – 09.2021 · K&K Brands (USA/Brazil) — buyer & data analyst, international trade",
      "02.2018 – 12.2018 · Alcon-Novartis (USA) — production & process improvement",
      "05.2015 – 11.2017 · Thriftshopper (USA) — logistics",
      "10.2005 – 03.2015 · Polícia Civil (Brazil) — criminal investigator"
    ],
    "educationItems": [
      "B.A. Business Administration (BWL) — PUCRS, Brazil · KMK-recognized in Germany",
      "Application & Database Development — Comcave College, Germany (2025–2026)",
      "Oracle Java SE Certification (OCA/OCP) — in progress",
      "Full-Stack Development — DIO (2023–2024)"
    ]
  },
  "viewOnGithub": "View on GitHub",
  "viewOnGithubFrontend": "Frontend on GitHub",
  "viewDocs": "Documentation hub",
  "urlLabel": "View Live Application",
  "impressumLink": "Impressum",
  "datenschutzLink": "Privacy Policy",
  "apiRefLabel": "API reference",
  "legal": {
    "impressumHeading": "Impressum",
    "impressumContent": "<p>Information according to § 5 DDG (formerly TMG)</p><p>Carlos Keglevich</p><p><strong>Contact:</strong><br/>Email: click the envelope icon to contact</p><p><strong>Responsible for content:</strong><br/>Carlos Keglevich</p><h4>Liability for content</h4><p>The contents of this website were created with the greatest care. However, no guarantee can be given for the accuracy, completeness and topicality of the contents.</p><h4>Liability for links</h4><p>This website contains links to external third-party websites, over which I have no influence. Therefore, I cannot accept any liability for these external contents. The respective provider or operator of the pages is always responsible for the content of the linked pages.</p><h4>Copyright</h4><p>The content and works created by the site operator on these pages are subject to German copyright law.</p>",
    "datenschutzHeading": "Privacy Policy",
    "datenschutzContent": "<p>This website respects your privacy. No personal data is actively collected, stored, or shared without your consent.</p><p>The website does not use cookies, analytics, or tracking services. Server logs may be collected by the hosting provider for security and performance and are deleted automatically within a reasonable period.</p><p>If you contact me by e-mail, the information you provide (such as your name, email address, and message) will be processed solely to respond to your inquiry.</p><p>Last updated: October 2025</p>"
  },
  "hero": {
    "eyebrow": "Java · Spring Boot · Full-Stack · Fürth",
    "headlinePre": "I turn business problems into",
    "headlineHighlight": "production-ready Java systems.",
    "lead": "Backend-focused developer with domain depth from procurement, manufacturing and public service — shipping secured Spring Boot APIs with real CI/CD, where done means tested, documented, and deployed.",
    "ctaProjects": "View projects",
    "ctaCv": "Download CV",
    "ctaExperience": "Experience"
  },
  "theme": { "light": "Light theme", "dark": "Dark theme" },
  "skills": "Technologies",
  "contact": "Contact",
  "skillsSection": {
    "backend": "Backend", "ai": "KI / AI", "frontend": "Frontend", "devops": "DevOps & Testing", "databases": "Databases",
    "backendDesc": "Three production Spring Boot systems with secured REST APIs — my core stack, the newest on Spring Boot 4 with Spring Modulith and Keycloak.",
    "aiDesc": "A RAG assistant in production: pgvector retrieval, embeddings, and EU-hosted LLM inference via IONOS — answers grounded in cited sources.",
    "frontendDesc": "Two Angular 22 apps shipped, plus React for this portfolio and SmartSupplyPro — bilingual interfaces with runtime language switching.",
    "devopsDesc": "Multi-workflow CI/CD with coverage and audit gates, Docker deployments, and end-to-end tests with Playwright — built from scratch, not copied.",
    "databasesDesc": "PostgreSQL with pgvector and Oracle Autonomous DB in production; SQL from years of data analysis."
  },
  "contactSection": {
    "heading": "Contact",
    "lead": "Questions about a project, feedback, or an idea you'd like to discuss? The fastest way to reach me is this form or LinkedIn.",
    "name": "Name", "email": "Email", "message": "Message",
    "consent": "I have read the privacy policy and consent to the processing of my data to answer my request.",
    "send": "Send message", "sending": "Sending…", "clear": "Clear fields",
    "success": "Thanks — your message has been sent. I will get back to you shortly.",
    "error": "Something went wrong. Please try again or reach me via LinkedIn or email."
  },
  "portfolioMeta": {
    "text": "This website itself is built to the same standard:",
    "source": "Source code", "docs": "Documentation", "coverage": "Test coverage"
  }
}
